import { useHttp, useIp } from '@/composables';
import { useAuthStore } from '@/stores';

export function useNotification() {
  const http = useHttp();
  const ips = useIp();
  const authStore = useAuthStore();

  const getCurrentUser = () => {
    const userId = authStore.user?.id_user;
    const userName = authStore.user?.name || 'Usuário';
    
    return { userId, userName };
  };

  const createNotification = async (payload) => {
    try {
      const { userId } = getCurrentUser();
      
      if (!userId) {
        console.warn('Usuário não está logado, não é possível criar notificação');
        return null;
      }

      const notificationPayload = {
        ...payload,
        created_by: payload.created_by || userId
      };
      
      const response = await http.post(ips.ipSecurity + 'notifications', notificationPayload);
      return response?.data || null;
    } catch (err) {
      console.error("Erro ao criar notificação:", err);
      
      if (err.response?.status === 403) {
        console.warn('Você não possui permissão para criar notificações.');
      }
      
      return null;
    }
  };

  const createChecklistNotification = async (action, proposalId, proposalDescription) => {
    if (!proposalId) {
      console.warn('ID da proposta não fornecido, notificação não será criada');
      return null;
    }
  
    const { userId, userName } = getCurrentUser();
    if (!userId) return null;
  
    const actionConfig = getActionConfig(action, proposalDescription, userName);
    if (!actionConfig) {
      console.warn(`Ação desconhecida: ${action}, notificação não será criada`);
      return null;
    }
  
    let link = '';
    if (action.endsWith('_shipment')) {
      link = `/stock/checklist-shipment/${proposalId}`;
    } else if (action.endsWith('_return')) {
      link = `/stock/checklist-return/${proposalId}`;
    } else {
      link = `/stock/checklist/${proposalId}`;
    }
  
    return createNotification({
      message: actionConfig.message,
      category: 'checklist',
      priority: actionConfig.priority,
      created_by: userId,
      related_entity_type: 'proposal',
      related_entity_id: proposalId,
      link
    });
  };

  const getActionConfig = (action, proposalDescription, userName) => {
    const configs = {
      start_shipment: {
        message: `Embarque da proposta "${proposalDescription}" iniciado por ${userName}`,
        priority: 'Importante'
      },
      end_shipment: {
        message: `Embarque da proposta "${proposalDescription}" finalizado por ${userName}`,
        priority: 'Importante'
      },
      restart_shipment: {
        message: `Embarque da proposta "${proposalDescription}" reinicializado por ${userName}`,
        priority: 'Normal'
      },
      start_return: {
        message: `Desembarque da proposta "${proposalDescription}" iniciado por ${userName}`,
        priority: 'Importante'
      },
      end_return: {
        message: `Desembarque da proposta "${proposalDescription}" finalizado por ${userName}`,
        priority: 'Importante'
      },
      restart_return: {
        message: `Desembarque da proposta "${proposalDescription}" reinicializado por ${userName}`,
        priority: 'Normal'
      }
    };

    return configs[action] || null;
  };

  const createTechListNotification = async (proposalId, proposalDescription, isNew = false) => {
    const { userId, userName } = getCurrentUser();
    
    if (!userId || !proposalId) return null;

    const actionText = isNew ? 'criada' : 'atualizada';

    return createNotification({
      message: `Lista técnica '${proposalDescription}' ${actionText} por ${userName}.`,
      link: `/stock/operational-extra-products/${proposalId}`,
      category: 'lista_tecnica',
      priority: 'Normal',
      related_entity_type: 'proposal',
      related_entity_id: proposalId,
      created_by: userId
    });
  };

  const createProposalNotification = async (proposalId, proposalDescription, isNew = false) => {
    const { userId, userName } = getCurrentUser();
    
    if (!userId || !proposalId) return null;

    const actionText = isNew ? 'criada' : 'atualizada';

    return createNotification({
      message: `Proposta "${proposalDescription}" foi ${actionText} por ${userName}`,
      category: 'proposta',
      priority: 'Normal',
      related_entity_type: 'proposal',
      related_entity_id: proposalId,
      link: `/proposals/editor?id=${proposalId}`
    });
  };

  return {
    createNotification,
    createChecklistNotification,
    createTechListNotification,
    createProposalNotification
  };
}

export default useNotification; 